/*
 * Public API Surface of mercalink-fselib
 * Just a facade to index.ts
 */

export * from './lib/index';
